import { Message } from "element-ui";

let utils = {};

// 空值判断
utils.isEmpty = function (o) {
    if (o == undefined || o == '' || o == null) {
        return true;
    }
    return false;
};

// 成功提示
utils.success = function(msg = "成功") {
    Message.success({
        message: msg,
        customClass: "zd-el-message",
    });
};

// 成功提示
utils.error = function(msg = "失败") {
    Message.error({
        message: msg,
        customClass: "zd-el-message",
    });
};


// 页面加载
let pageLoading = null;
utils.showLoading = function(vm) {
    pageLoading = vm.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255,255, 0.9)",
    });
};

// 结束加载
utils.hideLoading = function(vm) {
    if (pageLoading) {
        pageLoading.close();
        pageLoading = null;
    }
};

// 文件
utils.saveExcelFile = function(data) {
    var fileName = data.fileName;
    // 判断空
    if (utils.isEmpty(fileName)) return;

    var bin = atob(data.base64.replace(/\s/g, ""));
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }

    var blob = new Blob([buffer.buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // 输出文件
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName);
    } else {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.target = "_blank";
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
    }
};
export default utils;